module.exports = __webpack_public_path__ + "img/tickets-error-visual.1ced3703.svg";